export const BASE_API_URL = 'https://pulpoia-ops.com/backend/nodeapi/'
//export const BASE_API_URL = 'http://localhost:3002/'
export const URL_LOGIN = BASE_API_URL + "pulpologin"
export const URL_FORGOT = BASE_API_URL + "forgotPassword"
// export const URL_DASHBOARD = BASE_URL_EDUCACION_DIGITAL + "dashboard?token="
export const URL_DASHBOARD = `${window.location.protocol}//${window.location.host}/` 